import { DEFAULT_MULTIPLIER, IMAGE_ASSETS, SPRITESHEET_FILE } from '../Enums/ImageAssets';
import './Components.scss';
import spritesheetData from '../data/sprite.json';
import { useWindowSize } from '../hooks/windowSize';

const getMultiplier = (propsMultiplier: number, width: number, height: number) => {
  let multiplier = propsMultiplier ? propsMultiplier : DEFAULT_MULTIPLIER;

  // scaling now is implemented differently in the game file for the whole area

  return multiplier > 0 ? multiplier : 1;
}

function SpritesheetAsset(props: {
  name: string,
  multiplier?: number

  // props below should be moved to <button> or some other component, which uses ImageAsset
  onClick?: any,
  disabled?: boolean,
  showPointerOnHover?: boolean,
  animate?: boolean
}) {

  const [width, height] = useWindowSize();

  const multiplier = getMultiplier(props.multiplier, width, height);

  function handleClick() {
    if (props.onClick) {
      props.onClick()
    }
  }

  const asset = spritesheetData.frames[props.name];

  if (!asset) {
    console.warn('missing spritesheet asset');
    return;
  }

  const style = {
    background: `url(${SPRITESHEET_FILE})`,
    width: asset.sourceSize.w * multiplier,
    height: asset.sourceSize.h * multiplier,
    backgroundPosition: `-${asset.frame.x * multiplier}px -${asset.frame.y * multiplier}px`,
    backgroundSize: `${spritesheetData.meta.size.w * multiplier}px ${spritesheetData.meta.size.h * multiplier}px`
  };

  const animateClass = props.animate && !props.disabled ? 'animate' : '';

  return (
    <>
      {props.animate && !props.disabled &&
        <style>
          {`
            @keyframes shine {
              0% { filter: brightness(1); }
              50% { filter: brightness(1.3); }
              100% { filter: brightness(1); }
            }
            .asset.animate {
              animation: shine 0.7s infinite ease-in-out;
            }
          `}
        </style>
      }
      <div className={`asset ${props.showPointerOnHover ? 'show-pointer' : ''} ${props.disabled ? 'disabled' : ''} ${animateClass}`}
        style={style}
        onClick={handleClick}
      />
    </>
  );
}

export default SpritesheetAsset;
